import styles from '../styles.jcss'
import Icon from '../../../../blocks.simple/icon/icon'
import { colors } from '../../../../theme'
import { Typography } from '../../../../atoms/Typography'
import translate from '../../../../core/translate'
import helpers from '../../../../core/helpers'
import React from 'react'

export const Legend = ({
    showDisplayStatuses,
    setShowDisplayStatuses,
}: {
    showDisplayStatuses: boolean
    setShowDisplayStatuses: (value: boolean) => void
}) => {
    return (
        <div className={styles.sidebarHeader}>
            <div className={styles.sidebarHeaderCaption} onClick={() => setShowDisplayStatuses(!showDisplayStatuses)}>
                <Icon type={'infoFill'} size={15} color={colors.blueAccent} />
                <Typography type={'title'} className={styles.captionText}>
                    {translate('devicesStatuses')}
                </Typography>
            </div>
            {showDisplayStatuses && (
                <div className={styles.sidebarHeaderDropdownContent}>
                    <div className={styles.sidebarHeaderStatus}>
                        <Icon type={'displayIcon'} size={36} color={colors.online} />
                        <div className={styles.sidebarHeaderStatusInfo}>
                            <div className={styles.sidebarHeaderStatusInfoCaption}>{translate('online')}</div>
                            <div className={styles.sidebarHeaderStatusInfoDescription}>
                                {translate('deviceIsOnline')}
                            </div>
                        </div>
                    </div>
                    <div className={styles.sidebarHeaderStatus}>
                        <Icon type={'displayIcon'} size={36} color={colors.displayOff} />
                        <div className={styles.sidebarHeaderStatusInfo}>
                            <div className={styles.sidebarHeaderStatusInfoCaption}>{translate('displayOff')}</div>
                            <div className={styles.sidebarHeaderStatusInfoDescription}>
                                {translate('deviceIsOnlineDisplayOff')}
                            </div>
                        </div>
                    </div>
                    <div className={styles.sidebarHeaderStatus}>
                        <Icon type={'displayIcon'} size={36} color={colors.sleep} />
                        <div className={styles.sidebarHeaderStatusInfo}>
                            <div className={styles.sidebarHeaderStatusInfoCaption}>{translate('sleepMode')}</div>
                            <div className={styles.sidebarHeaderStatusInfoDescription}>
                                {translate('deviceIsSleepMode')}
                            </div>
                        </div>
                    </div>
                    {helpers.isEnabledPingSupport() && (
                        <div className={styles.sidebarHeaderStatus}>
                            <Icon type={'displayIcon'} size={36} color={colors.ping} />
                            <div className={styles.sidebarHeaderStatusInfo}>
                                <div className={styles.sidebarHeaderStatusInfoCaption}>{translate('pingMode')}</div>
                                <div className={styles.sidebarHeaderStatusInfoDescription}>
                                    {translate('deviceInPingMode')}
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={styles.sidebarHeaderStatus}>
                        <Icon type={'displayIcon'} size={36} color={colors.offline} />
                        <div className={styles.sidebarHeaderStatusInfo}>
                            <div className={styles.sidebarHeaderStatusInfoCaption}>{translate('offline')}</div>
                            <div className={styles.sidebarHeaderStatusInfoDescription}>
                                {translate('deviceIsOffline')}
                            </div>
                        </div>
                    </div>
                    <div className={styles.sidebarHeaderStatus}>
                        <Icon type={'displayIcon'} size={36} color={colors.warning} />
                        <div className={styles.sidebarHeaderStatusInfo}>
                            <div className={styles.sidebarHeaderStatusInfoCaption}>{translate('updating')}</div>
                            <div className={styles.sidebarHeaderStatusInfoDescription}>
                                {translate('deviceIsUpdating')}
                            </div>
                        </div>
                    </div>
                    <div className={styles.sidebarHeaderStatus}>
                        <Icon type={'displayIcon'} size={36} color={colors.error} />
                        <div className={styles.sidebarHeaderStatusInfo}>
                            <div className={styles.sidebarHeaderStatusInfoCaption}>{translate('error')}</div>
                            <div className={styles.sidebarHeaderStatusInfoDescription}>
                                {translate('deviceHaveError')}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
